import styled from 'styled-components'
import { CamelCaseListing } from '../types'

const BannerWrapper = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-warning-200']?.value};
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xxxs']?.['font-size']?.value};
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 8px;
  text-align: center;
  margin-top: -5px;
  position: relative;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;

  strong {
    font-weight: 700;
  }
`
const DiscountBanner = ({
  discount,
}: {
  discount: CamelCaseListing['discount']
}) => {
  if (!discount) return null
  if (
    discount.percentage < 10 ||
    (discount.typename === 'LongStayDiscount' && discount.durationInNights < 3)
  )
    return null

  return (
    <BannerWrapper>
      {discount.typename === 'LongStayDiscount' && 'Long stay '}
      <strong>{discount.percentage}% off</strong>
      {discount.typename === 'PromotionalDiscount' && ` ${discount.name}`}
    </BannerWrapper>
  )
}

export default DiscountBanner
